import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

import MainLayout from "../layouts/MainLayout";

const Home = lazy(() => import("../pages/Home/Home.jsx"));
const PrivacyPolicy = lazy(() => import("../pages/PrivacyPolicy/PrivacyPolicy"));
const Terms = lazy(() => import("../pages/Terms/Terms"));
const CheckUp = lazy(() => import("../pages/CheckUp/CheckUp.jsx"));
const Checkout = lazy(() => import("../pages/Checkout/Checkout.jsx"));
const About = lazy(() => import("../pages/About/About.jsx"));
const Equipment = lazy(() => import("../pages/Equipment/Equipment.jsx"));
const Gallery = lazy(() => import("../pages/Gallery/Gallery.jsx"));
const VirtualWalk = lazy(() => import("../pages/VirtualWalk/VirtualWalk.jsx"));
const HowToStart = lazy(() => import("../pages/HowToStart/HowToStart.jsx"));
const Cooperation = lazy(() => import("../pages/Cooperation/Cooperation.jsx"));
const NotFound = lazy(() => import("../pages/NotFound/NotFound.jsx"));
const Reservation = lazy(() => import("../pages/Reservation/Reservation.jsx"));
const PaymentSuccess = lazy(() => import("../pages/PaymentSuccess/PaymentSuccess.jsx"));
const PaymentFailed = lazy(() => import("../pages/PaymentFailed/PaymentFailed.jsx"));
const GymPass = lazy(() => import("../pages/GymPass/GymPass.jsx"));
const Offer = lazy(() => import("../pages/Offer/Offer.jsx"));
const Contact = lazy(() => import("../pages/Contact/Contact.jsx"));
const Trasa = lazy(() => import("../pages/Trasa/Trasa.jsx"));
const ReportIssue = lazy(() => import("../pages/ReportIssue/ReportIssue.jsx"));


export default function AppRoutes() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
          <Route path="/regulamin" element={<Terms />} />
          <Route path="/ai-checkup" element={<CheckUp />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/o-nas" element={<About />} />
          <Route path="/wyposazenie" element={<Equipment />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/wirtualny-spacer" element={<VirtualWalk />} />
          <Route path="/jak-zaczac" element={<HowToStart />} />
          <Route path="/wspolpraca" element={<Cooperation />} />
          <Route path="/rezerwacja" element={<Reservation />} />
          <Route path="/success" element={<PaymentSuccess />} />
          <Route path="/failed" element={<PaymentFailed />} />
          <Route path="/karnet" element={<GymPass />} />
          <Route path="/oferta" element={<Offer />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/trasa" element={<Trasa />} />
          <Route path="/report-issue" element={<ReportIssue />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
